<script>
import helpers from '../helpers';

export default {
  name: 'AuditTable',
  props: {
    isLoading: {
      type: Boolean,
      required: true,
      default: true,
    },
    items: {
      type: Array,
      required: true,
    },
    pagination: {
      type: Object,
      default: () => ({
        page: 1,
        pageSize: 2,
        total: 0,
      }),
    },
    transactionId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    fields: [
      { key: 'uuid', label: 'UUID' },
      { key: 'target_type', label: 'Target Type' },
      { key: 'target_id', label: 'Target ID' },
      { key: 'target_reference', label: 'Target Reference' },
      { key: 'entity_type', label: 'Entity Type' },
      { key: 'entity_id', label: 'Entity ID' },
      { key: 'client_id', label: 'Client ID' },
      { key: 'more', label: 'More' },
    ],
  }),
  methods: {
    formatID(id) {
      if (!id) {
        return 'No ID';
      }

      return id.length > 12 ? `${id.slice(0, 12)}...` : id;
    },
    formatReference(reference) {
      if (!reference) {
        return 'No reference';
      }

      return reference;
    },
    emitPageChange(newPage) {
      const pagination = { ...this.pagination, page: newPage };
      const createdAt = this.items[0].created_at;
      this.$emit('pagination-changed', this.transactionId, pagination, createdAt);
    },
    emitPerPageChange(newPerPage) {
      const pagination = { ...this.pagination, page: 1, pageSize: newPerPage };
      const createdAt = this.items[0].created_at;
      this.$emit('pagination-changed', this.transactionId, pagination, createdAt);
    },
    logHasDiff(logData) {
      return (
        logData.action_type === 'modification'
        && !helpers.isNullOrEmpty(logData.entity_id)
        && !helpers.isNullOrEmpty(logData.diff_uuid)
        && logData.diff_uuid !== 'no-diff'
      );
    },
  },
};
</script>

<template>
  <div>
    <b-row>
      <b-col>
        <b-table
          id="audit-logs-table"
          :fields="fields"
          :items="items"
          :busy="isLoading"
          table-variant="info"
          hover
          show-empty
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle" />
              <strong>Loading...</strong>
            </div>
          </template>
          <template #empty>
            <div class="text-center my-2">
              <strong>No transactions logs to show</strong>
            </div>
          </template>
          <template #cell(uuid)="data">
            <span v-b-tooltip.hover.top="data.item.uuid">
              {{ formatID(data.item.uuid) }}
            </span>
          </template>
          <template #cell(target_id)="data">
            <span v-b-tooltip.hover.top="data.item.target_id">
              {{ formatID(data.item.target_id) }}
            </span>
          </template>
          <template #cell(target_reference)="data">
            <span v-b-tooltip.hover.top="data.item.target_id">
              {{ formatReference(data.item.target_reference) }}
            </span>
          </template>
          <template #cell(entity_id)="data">
            <span v-b-tooltip.hover.top="data.item.entity_id">
              {{ formatID(data.item.entity_id) }}
            </span>
          </template>
          <template #cell(more)="data">
            <div class="d-flex justify-content-center">
              <b-button
                v-b-tooltip.hover.top="
                  logHasDiff(data.item)
                    ? 'Show changes'
                    : 'Diff not available'
                "
                :disabled="!logHasDiff(data.item)"
                variant="primary"
                size="sm"
                :class="logHasDiff(data.item) ? '' : 'cursor-not-allowed'"
                @click="$emit('show-sublog-details', data.item)"
              >
                <feather
                  class="mb-0"
                  type="columns"
                  stroke="white"
                />
              </b-button>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <b-row align-h="between">
      <b-col md="3">
        <label>Total Logs: {{ pagination.total }}</label>
      </b-col>
      <b-col
        md="3"
      >
        <b-pagination
          align="center"
          :value="pagination.page"
          :total-rows="pagination.total"
          :per-page="pagination.pageSize"
          @change="emitPageChange"
        />
      </b-col>
      <b-col md="3">
        <b-form
          inline
          class="d-flex justify-content-end"
        >
          <label for="per-page">Per Page</label>
          <b-form-select
            id="per-page"
            v-model="pagination.pageSize"
            class="ml-2"
            :options="[10, 20, 30, 50, 100]"
            @change="emitPerPageChange"
          />
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<style>
.cursor-not-allowed {
  cursor: not-allowed !important;
}
</style>
